/**
 * @author xyguo
 * @description 角色管理==》人员维护==》添加人员管理页面,可在该角色下添加人员
 * @Date 2020/1/2
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool ,utils_tool} from "@/tool";
import ListSelect from "./listSelect";
import {modelUtils} from "../../../../../utils";

let {$$} = utils_tool;
const { WizContainer, WizReduxTemplate } = framework_tool;
const {
  WizTabs,
  WizCard
} = component_tool;

class roleGroupAddList extends WizContainer {
  componentName = "roleGroupAddList";

  constructor(props) {
    super(props);
    this.state = {
      selectedRows: []
    };
  }

  static defaultProps = {
    _ok: this._ok
  };

  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = (data) => {
    const {roleId} = data;
    let listDate = this.state.selectedRows;
    const groupIds = [];
    if (!listDate || ($$.isArray(listDate) && !(listDate).length)) {
      wizNotice.warn("请先选择用户组");
    } else {
      listDate.forEach(recordData => {
        groupIds.push(
          recordData.id
        )
      });
      this.doAction({
        path: "roleGroup/addGroupsForRole",
        payload: {
          key: "addGroupsForRoleKey",
          apiParams: {
            "roleId": roleId,
            "groupIds": groupIds
          }
        }
      });
    }
  };

  updateRows = rows => {
    this.setState({
      rowData: new Date().getTime(),
      selectedRows: rows
    });
  };

  handleClear(id) {
    const { selectedRows } = this.state;
    id
      ? this.setState({
          selectedRows: selectedRows.filter(item => item.id !== id)
        })
      : this.setState({
          selectedRows: []
        });
  }

  propsAndStateOnChange = {
    roleGroupAddResult: this._setGroupUserAddState.bind(this)
  };

  _setGroupUserAddState(nextProps, nextState) {
    if (nextProps.roleGroupAddResult.code === 1) {
      wizNotice.success("操作成功");
      this.props.changeModal(false, true);
    } else {
      wizNotice.error(nextProps.roleGroupAddResult.msg);
    }

  }



  _render() {
    // let record = this.props.location.record;
    return (
      <WizCard>
          <ListSelect
            selectedRows={this.state.selectedRows}
            updateRows={rows => this.updateRows(rows)}
            handleClear={id => this.handleClear(id)}
            roleId={this.props.roleId}
          />
       </WizCard>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {roleGroup} = state;
  const roleGroupAddResult = modelUtils.getModelEntity(roleGroup, 'addGroupsForRoleKey');
  return {
    roleGroupAddResult: roleGroupAddResult
  };
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(roleGroupAddList);
